"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const hasPausedSinceObstacle = () => {
    if (state_1.default.pauses.length > 0) {
        return state_1.default.pauses[state_1.default.pauses.length - 1].pausedAt >= state_1.default.hitObstacleAt;
    }
    return false;
};
exports.default = hasPausedSinceObstacle;
